import React from "react";
// import LoadingSpinner from "../utils/LoadingSpinner";
import Tooltip from "../../utils/Tooltip";
import ChangeRate from "./ChangeRate";
import {
  CalcContainer,
  StyledSessionNum,
  StyledStatsCard,
  StyledStatsCardTitle,
} from "../dashboard.style";

const StatsCard = ({ tooltipContent, cardTitle, sessionNum, changeRate }) => {
  return (
    <Tooltip content={tooltipContent}>
      <StyledStatsCard>
        <StyledStatsCardTitle>{cardTitle}</StyledStatsCardTitle>
        <CalcContainer>
          <StyledSessionNum>
            {typeof sessionNum === "number" ? (
              sessionNum.toLocaleString("en", { useGrouping: true })
            ) : (
              <p>Loading...</p>
            )}
          </StyledSessionNum>
          <ChangeRate changeRate={changeRate} />
        </CalcContainer>
      </StyledStatsCard>
    </Tooltip>
  );
};

export default StatsCard;
